export Landing from './Landing';



// WEBPACK FOOTER //
// ./src/modules/landing/containers/index.js